import { render, staticRenderFns } from "./itemReleaseUndoList.vue?vue&type=template&id=22afaa3d&scoped=true"
import script from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
export * from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseUndoList.vue?vue&type=style&index=0&id=22afaa3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afaa3d",
  null
  
)

export default component.exports